import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  chooseInsuranceRequest,
  changePrimePercentageRequest,
  chooseFinancingOptionRequest,
  changePlazoRequest,
} from '../../actions';
import { useParams } from 'react-router-dom';
import Finance from '../../components/Finance';
import useCar from '../../utils/hooks/useCar';

const FinanceContainer = () => {
  const dispatch = useDispatch();
  const { tipo, modelo, version, anio, color } = useParams();
  const {
    insuranceList,
    isLoading,
    financeOptions,
    prime,
    colorCode,
    plazo,
    car
  } = useSelector(state => ({
    car: state.personalization.data || {},
    colorCode: state.personalization.data?.colorCode,
    insuranceList: state.personalization.data?.insurances,
    isLoading: state.personalization.isLoading,
    financeOptions: state.personalization.additional?.bancos || [],
    price:
      Number(state.personalization.data?.precioOferta) ||
      Number(state.personalization.data?.precioPublico) ||
      0,
    prime: state.personalization.additional?.prima || 0,
    plazo: state.personalization.additional?.plazo || 96,
  }));

  const { finalPrice, carPrice } = useCar(car);
  
  // const financeOptions = [
  //   { id: 1, nombre: 'BAC', tasa: 11.95, plazo: 60 },
  //   { id: 2, nombre: 'Scotia', tasa: 11.95, plazo: 60 },
  //   { id: 3, nombre: 'Scotia', tasa: 11.95, plazo: 60 },
  //   { id: 4, nombre: 'Scotia', tasa: 11.95, plazo: 60 },
  //   { id: 5, nombre: 'Scotia', tasa: 11.95, plazo: 60 },
  //   { id: 6, nombre: 'Scotia', tasa: 11.95, plazo: 60 },
  //   { id: 7, nombre: 'Scotia', tasa: 11.95, plazo: 60 },
  //   { id: 8, nombre: 'Scotia', tasa: 11.95, plazo: 60 },
  // ];
  const changeInsurance = insurance =>
    dispatch(
      chooseInsuranceRequest(tipo, modelo, version, anio, color, insurance)
    );
  const changePrimePercentage = useCallback(
    prime =>
      dispatch(
        changePrimePercentageRequest(tipo, modelo, version, anio, color, prime)
      ),
    [anio, color, dispatch, modelo, tipo, version]
  );

  const selectFinancingOption = useCallback(
    option =>
      dispatch(
        chooseFinancingOptionRequest(tipo, modelo, version, anio, color, option)
      ),
    [anio, color, dispatch, modelo, tipo, version]
  );

  const changePlazo = useCallback(
    plazo =>
      dispatch(
        changePlazoRequest(tipo, modelo, version, anio, color, plazo)
      ),
    [anio, color, dispatch, modelo, tipo, version]
  );
  return (
    <Finance
      insuranceList={insuranceList}
      financeOptions={financeOptions}
      isLoading={isLoading}
      changeInsurance={changeInsurance}
      price={finalPrice}
      prime={prime}
      changePrimePercentage={changePrimePercentage}
      selectFinancingOption={selectFinancingOption}
      changePlazo={changePlazo}
      colorCode={colorCode}
      plazo={plazo}
      car={car}
      carPrice={carPrice}
    />
  );
};

export default FinanceContainer;
